
angular.module('dyb.students.overview', [
        'dybTags', 'classy', 'classy-on', 'classy.models',
        'LocalStorageModule']);
